export default __webpack_public_path__ + "3541f6e4f9f623762a0afced746cee3d.svg";